import { Box, CircularProgress, Typography } from '@mui/material';
import { LocalizationKeys } from 'assets/localizations/localizationKeys';
import { observer } from 'mobx-react';
import React from 'react';
import { useStores } from 'stores/storeInitializer';

/**
 * "Checking the CUI..." while the company is being verified. Stateless: the page mounts it only while a lookup is
 * in flight. A polite live region, so assistive technology announces it without interrupting; the spinner itself is
 * decorative (the text says what is happening).
 */
export const LookupProgress: React.FC = observer(() => {
    const { store } = useStores();

    return (
        <Box role="status" aria-live="polite" sx={{ display: 'flex', alignItems: 'center', gap: 1.5, px: 0.5 }}>
            <CircularProgress size={20} aria-hidden="true" />
            <Typography variant="body2" color="text.secondary">
                {store.L(LocalizationKeys.BillingDetailsVerifying)}
            </Typography>
        </Box>
    );
});

export default LookupProgress;
